import { Ifo } from './types';

const ifos: Ifo[] = [];

export default ifos;
